module.exports = __webpack_public_path__ + "media/images/en/upload-dashboard-fa8f85e0188e8ee34b32fe293c68dc7a.png";